// Description: This file contains the entity constants.

export const ENTITY_CONSTANTS = {
    order: 'Order',
    quote: 'Quote',
    production: 'Production',
    workspace: 'Workspace',
    organization: 'Organization',
    person: 'Person',
    booking: 'Booking',
    shortlistLineitem: 'ShortlistLineItem',
    activity: 'Activity',
    opportunity: 'Opportunity',
    reservation: 'Reservation',
    account: 'Account',
    productOwnerOrganization: 'ProductOwnerOrganization',
    opportunityLineItem: 'OpportunityLineItem',
    shortlist: 'Shortlist',
    document: 'Document',
    preference: 'Preference',
    crewHire: 'CrewHire',
    product: 'Product',
    calendar: 'Calendar',
    rate: 'Rate',
    engagement: 'Engagement',
    note: 'Note',
    financialLine: 'FinancialLine',
    attachment: 'Attachment',
    resource: 'Resource',
    fieldDefinition: 'FieldDefinition',
    term: 'Term',
    deal: 'Deal'
} as const;

export const ENTITY_REFERENCE_LABEL = {
    reference: 'reference',
    personReference: 'personReference'
};
